import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE, LB_NAME, LB_ACTIVE} from "../../../components/i18n/i18n";
import {PH_CODE, PH_NAME} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";



const DynamicModuleFilter = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const {fbDataBase} = app

    const [status, setStatus] = useState(filter?.status || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            name: filter?.name || '',
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data,
                dynamicModule:true }
        };

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        reset({
            name: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_NAME}</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder={PH_NAME}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>{LB_ACTIVE}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(DynamicModuleFilter)